var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.374,
    height: 12.352,
    viewBox: "0 0 12.374 12.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3377",
    "data-name": "Rectangle 3377",
    width: 12.374,
    height: 12.352,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10078",
    "data-name": "Group 10078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10077",
    "data-name": "Group 10077",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27157",
    "data-name": "Path 27157",
    d: "M9.265,8.2a1.232,1.232,0,0,0-1.749,0l-.6.6a10.774,10.774,0,0,1-1.856-1.49,11.074,11.074,0,0,1-1.49-1.856l.6-.6a1.232,1.232,0,0,0,0-1.749L3.006,1.946a1.205,1.205,0,0,0-.868-.362,1.243,1.243,0,0,0-.877.362L.7,2.5a2.622,2.622,0,0,0-.675,2.16,8.726,8.726,0,0,0,2.7,4.964,8.868,8.868,0,0,0,4.981,2.72,3.018,3.018,0,0,0,.345,0,2.5,2.5,0,0,0,1.815-.675l.555-.56a1.243,1.243,0,0,0,.362-.877,1.206,1.206,0,0,0-.362-.868Zm.581,2.328-.56.555A1.879,1.879,0,0,1,7.78,11.5,7.98,7.98,0,0,1,3.332,9.028,8.073,8.073,0,0,1,.85,4.593a1.863,1.863,0,0,1,.412-1.507l.581-.56a.415.415,0,0,1,.583,0L3.591,3.7a.414.414,0,0,1,0,.581l-.823.823a.409.409,0,0,0-.066.5A11.275,11.275,0,0,0,4.483,7.9a11.287,11.287,0,0,0,2.3,1.783.411.411,0,0,0,.5-.066L8.1,8.795a.414.414,0,0,1,.581,0L9.846,9.958a.423.423,0,0,1,.12.294.4.4,0,0,1-.12.278m.716-8.724A6.134,6.134,0,0,0,6.2,0a.412.412,0,1,0,0,.823,5.354,5.354,0,0,1,5.35,5.4.412.412,0,1,0,.823,0,6.135,6.135,0,0,0-1.811-4.411",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27158",
    "data-name": "Path 27158",
    d: "M13.213,6.3a2.48,2.48,0,0,1,.729,1.775.412.412,0,0,0,.823,0,3.294,3.294,0,0,0-3.292-3.335.412.412,0,1,0,0,.823,2.478,2.478,0,0,1,1.741.738",
    transform: "translate(-4.991 -2.138)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.33ad924b342b47c81912e4f5ff8ece6e.svg";
export { ForwardRef as ReactComponent };